import React, { useEffect, useState } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearEmpresa from "../elementos/complejos/FormCrearEmpresa";
import FormEditarEmpresa from "../elementos/complejos/FormEditarEmpresa";
import FormCrearEmpresaColaboradora from "../elementos/complejos/FormCrearEmpresaColaboradora";
import FormEditarEmpresaColaboradora from "../elementos/complejos/FormEditarEmpresaColaboradora";
import FormCrearNegocio from "../elementos/complejos/FormCrearNegocio";
import FormEditarNegocio from "../elementos/complejos/FormEditarnegocio";
import { fetchDepartamentosData, } from '../../peticiones_API/PeticionesGestionPersonasEmpresas';

const GestorEmpresa = ({ crear, tipo = "normal" }) => {
  const [loading, setLoading] = useState(true);
  const [departamentos, setDepartamentos] = useState([]);

  useEffect(() => {
      const fetchData = async () => {
        try {
          if (departamentos.length === 0) {
        const departamentosResponse = await fetchDepartamentosData();
        setDepartamentos(departamentosResponse);
          }
        } catch (error) {
          console.log("Ha habido un error:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);

    if (loading) {
      return <div>Cargando...</div>;
    }
    
  return (
    <>
      <ContenedorPrincipal formaform="true">
      {tipo === "colaboradora" ? (
        crear ? <FormCrearEmpresaColaboradora /> : <FormEditarEmpresaColaboradora />
      ) : tipo === "empresa" ? ( //Hay que cambiar el nombre de los componentes de las empresas a negocios y lo contrario
        
        crear ? <FormCrearEmpresa /> : <FormEditarEmpresa />
      ) :
      (
        crear ? <FormCrearNegocio departamentos={departamentos}/> : <FormEditarNegocio departamentos={departamentos}/> 
      )
      }
      </ContenedorPrincipal>
    </>
  );
}

export default GestorEmpresa;